import { QueryClientProvider } from '@tanstack/react-query';
import { useEffect, type ReactNode } from 'react';
import { Toaster } from '@/components/ui/toaster';
import { queryClient } from './queryClient';
import { followSystemTheme } from './themeChoice';

/** Everything global around the router: the query cache, toasts, and the theme following the device. */
export function Providers({ children }: { children: ReactNode }) {
  useEffect(() => followSystemTheme(), []);

  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <Toaster />
    </QueryClientProvider>
  );
}
